import "babel-polyfill";

import SwHic, { Vue, App } from "sw-hic";
import "sw-hic/sw-hic.css";
import store from "@/common/store";
import router from "@/common/router";
Vue.use(SwHic);
Vue.config.productionTip = false;
if (process.env.NODE_ENV == "development") {
  // 引入mockjs
  // require('./common/mock.js')
}
new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
